// 获取中心点
function getPointsCenter(points) {
    let pointNum = points.length; // 坐标点个数
    let X = 0;
    let Y = 0;
    let Z = 0;
    for (let i = 0; i < points.length; i++) {
        let lat;
        let lng;
        let x;
        let y;
        let z;
        lat = (parseFloat(points[i][1]) * Math.PI) / 180;
        lng = (parseFloat(points[i][0]) * Math.PI) / 180;
        x = Math.cos(lat) * Math.cos(lng);
        y = Math.cos(lat) * Math.sin(lng);
        z = Math.sin(lat);
        X += x;
        Y += y;
        Z += z;
    }
    X /= pointNum;
    Y /= pointNum;
    Z /= pointNum;

    let tmpLng = Math.atan2(Y, X);
    let tmpLat = Math.atan2(Z, Math.sqrt(X * X + Y * Y));

    return { latitude: (tmpLat * 180) / Math.PI, longitude: (tmpLng * 180) / Math.PI };
}
// 获取地理位置
function getAreaInfo(coordArr) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open(
            'get',
            `https://restapi.amap.com/v3/geocode/regeo?key=eb4d15b428372525557ad06110e3afdb&location=${coordArr}`,
        );
        xhr.send();
        xhr.onload = resolve;
        xhr.onerror = reject;
    });
}
// 方法定义 lat,lng
function getDistance(lat1, lng1, lat2, lng2) {
    let radLat1 = (lat1 * Math.PI) / 180.0;
    let radLat2 = (lat2 * Math.PI) / 180.0;
    let a = radLat1 - radLat2;
    let b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
    let s = 2
        * Math.asin(
            Math.sqrt(
                Math.pow(Math.sin(a / 2), 2)
                    + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2),
            ),
        );
    s *= 6378.137; // EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000;
    return s;
}

function formatSongTime(duration = 0) {
    let time = 0;

    let s = Math.floor((duration / 1000) % 60);
    let m = Math.floor((duration / (1000 * 60)) % 60);
    let h = Math.floor((duration / (1000 * 60 * 60)) % 24);
    if (/^[0-9]+.?[0-9]*$/.test(h) && /^[0-9]+.?[0-9]*$/.test(m) && /^[0-9]+.?[0-9]*$/.test(s)) {
        if (h < 10) h = `0${h}`;
        if (m < 10) m = `0${m}`;
        if (s < 10) s = `0${s}`;
        time = `${h}:${m}:${s}`;
    }

    return time;
}
// 调用 return的距离单位为km
// GetDistance(10.0,113.0,12.0,114.0)

export { getPointsCenter, getAreaInfo, getDistance, formatSongTime };
